define('fukit/configuration/bluebird.configuration',['require','exports','module','bluebird'],function(require, exports, module) {
  var Promise = require('bluebird');

  var BluebirdConfiguration = {
    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    onAppConfigure: function() {
      window.Promise = Promise;
    },
  };

  module.exports = BluebirdConfiguration;
});

